import { DashboardSchematics } from "../../components/skins/dashboard-schematics.ts";
import { uploadSchematic } from "../../services/api.ts";
import { initSchematics } from "../../components/schematics/schematics-init.ts";
import { globalState } from "../../framework/globalState.ts";

export default function SchematicsPage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");
  container.innerHTML = new DashboardSchematics().schematicsskin();

  const siteWithData = globalState.currentSiteWithData;
  const site = (siteWithData as any)?.site || siteWithData;
  const devices = (siteWithData as any)?.devices || [];
  const registers = devices.flatMap(d =>
        (d.registers || []).map(r => ({ ...r, deviceName: d.name, deviceId: d._id }))
      );
  const siteId = site._id;

  const uploadBtn = container.querySelector("#upload-svg-btn");
  const fileInput = container.querySelector("#upload-svg-input");
  const canvas = container.querySelector(".schematics-canvas");

  uploadBtn.addEventListener("click", () => fileInput.click());

  fileInput.addEventListener("change", async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const res = await uploadSchematic(siteId, file.name, file);
      alert(`SVG uploaded: ${res.schematic.name}. Nodes generated: ${res.nodesGenerated}`);

      // Reload the schematic canvas
      await initSchematics(siteId, registers, ".schematics-canvas");

    } catch (err) {
      console.error(err);
      alert("Failed to upload SVG: " + err.message);
    }
  });

  // Load existing schematic on page load
  setTimeout(() => initSchematics(siteId, registers, ".schematics-canvas"), 0);

  return container;
}
